import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div
      className={`mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? 'md:flex-col md:items-center md:text-center' : ''
      }`}
    >
      <div className={isCenter ? 'flex flex-col items-center' : ''}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-medium tracking-wide text-primary-700">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-price-tag-3-line text-primary-600" aria-hidden="true" />
            </span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[28px]">
          {title}
        </h2>
        {description && (
          <p className={`mt-2 max-w-2xl text-sm leading-relaxed text-foreground-700 ${isCenter ? 'text-center' : ''}`}>
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}